import React from 'react';
import { Table, Tr, Td, Thead, Th } from 'reactable';

import DiversionModal from './DiversionModal';

const columnsByType = ['Country', 'numberInternationalIncidents', 'Additional Details'] ;

class DiversionTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeItem: null,
    };

    this.handleDescriptionClick = this.handleDescriptionClick.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleDescriptionClick(item) {
    return () => {
      this.setState({
        activeItem: item,
      });
    }
  }

  handleCloseModal() {
    this.setState({
      activeItem: null,
    });
  }

  renderThead() {
    const columns = ['Country', 'Number of Incidents', 'Additional Details'];

    return columns.map((column, index) => {
      return (
        <Th key={ index } column={ column }>
          { column }
        </Th>
      );
    });
  }

  renderTds(rowData, country) {
    let content = [
        <Td key="Country" column="Country">
           {country}
        </Td>,
        <Td key='Number of Incidents' column='Number of Incidents'>
          { rowData[this.props.number] }
        </Td>,
        <Td key='Additional Details' column='Additional Details'>
          <a onClick={ this.handleDescriptionClick(rowData) }>
            [Click for additional details]
          </a>
        </Td>
    ];
    return content.map(value => (value));
  }

  renderTrs() {
    const data = this.props.data;
    return Object.entries(data).map((entry) => {
      const [key, value] = entry;
      if (value[this.props.hasItem] == "5" || value[this.props.hasItem] == "Y") {
        return (<Tr key={key}>{ this.renderTds(value, key) }</Tr>)
      }
    });
  }

  renderNoData() {
    const type = this.props.type;

    return (
      <div className="no-needs-message">
        No { type } incidents reported
      </div>
    );
  }

  render() {
    const { data, description } = this.props;
    const { activeItem } = this.state;

    if (!data || data.length === 0) return this.renderNoData();

    return (
      <div className="oecd-table__container">
        <Table
          className="table oecd-table"
        >
          <Thead>
            { this.renderThead() }
          </Thead>
          { this.renderTrs() }
        </Table>

        <DiversionModal
          show={ !!activeItem }
          content={ activeItem && activeItem[description] }
          source={ activeItem && activeItem.source }
          onClose={ this.handleCloseModal }
        />
      </div>
    );
  }
}

export default DiversionTable;



// WEBPACK FOOTER //
// ./src/components/Diversion/DiversionTable.js